/**
 * Runtime scripts for chromeless HTML frame documents: breathing room above
 * and below the content, and a transparent document over the frame glass.
 * Inline edits are applied to the authored HTML, so neither needs undoing.
 */
export function chromelessInsetScript(insetBlockPx: number): string {
  const px = Math.max(0, Math.round(insetBlockPx));
  if (px === 0) return "";

  return `<script data-denker-runtime="chromeless-inset">
(function(){
  var inset=${px};
  function apply(){
    if(!document.body)return;
    var cs=getComputedStyle(document.body);
    var top=parseFloat(cs.paddingTop)||0;
    var bottom=parseFloat(cs.paddingBottom)||0;
    document.body.style.paddingTop=(top+inset)+"px";
    document.body.style.paddingBottom=(bottom+inset)+"px";
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",apply,{once:true});
  else apply();
})();
</scr${""}ipt>`;
}

export const CHROMELESS_TRANSPARENT_BACKGROUND_SCRIPT = `<script data-denker-runtime="chromeless-transparent-background">
(function(){
  // An authored page wrapper (body > main/article/section/div as the only
  // content) that paints its own backdrop would cover the frame glass.
  function soleChild(el){
    var only=null;
    for(var c=el.firstElementChild;c;c=c.nextElementSibling){
      if(/^(SCRIPT|STYLE|TEMPLATE|LINK|META)$/.test(c.tagName)||c.hasAttribute("data-denker-runtime"))continue;
      if(only)return null;
      only=c;
    }
    return only;
  }
  function clearWrapperBackgrounds(){
    for(var el=soleChild(document.body);el&&/^(MAIN|ARTICLE|SECTION|DIV)$/.test(el.tagName);el=soleChild(el)){
      var cs=getComputedStyle(el);
      if(cs.backgroundImage==="none"&&cs.backgroundColor.replace(/\\s/g,"")==="rgba(0,0,0,0)")continue;
      el.style.background="transparent";
    }
  }
  function apply(){
    if(!document.documentElement||!document.body)return;
    document.documentElement.style.background="transparent";
    document.documentElement.style.backgroundColor="transparent";
    document.documentElement.style.setProperty("--bg","transparent");
    document.body.style.background="transparent";
    document.body.style.backgroundColor="transparent";
    clearWrapperBackgrounds();
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",apply,{once:true});
  else apply();
})();
</scr${""}ipt>`;
